import client from '../../providers/fetchClient'

export const fetchAreaTypeIds = () => client.get('/v3/area-types')
